import { 
    faPlus, 
    faEdit, 
    faTrash, 
    faLanguage, 
    faFilePdf, 
    faFileExcel,
    faEye,
    faDownload,
    faUpload,
    faCopy,
    faSave,
    faTimes,
    faCheck,
    faSearch,
    faFilter,
    faRefresh,
    faArrowLeft,
    faArrowRight,
    faArrowsAlt,
    faPrint,
    faShare,
    faCog,
    faUser,
    faUsers,
    faBuilding,
    faBuildingColumns,
    faMapMarkerAlt,
    faCalendar,
    faClock,
    faLock,
    faUnlock,
    faKey,
    faBell,
    faHeart,
    faStar,
    faFlag,
    faExclamationTriangle,
    faInfoCircle,
    faQuestionCircle,
    faCheckCircle,
    faTimesCircle,
    faExclamationCircle,
    faMinus,
    faPlusCircle,
    faMinusCircle,
    faArrowUp,
    faArrowDown,
    faSort,
    faSortUp,
    faSortDown,
    faExpand,
    faCompress,
    faExternalLinkAlt,
    faLink,
    faUnlink,
    faEdit as faPencil,
    faTrash as faDelete,
    faCopy as faDuplicate,
    faSave as faFloppyDisk,
    faTimes as faClose,
    faCheck as faCheckmark,
    faSearch as faMagnifyingGlass,
    faFilter as faFunnel,
    faRefresh as faSync,
    faArrowLeft as faChevronLeft,
    faArrowRight as faChevronRight,
    faPrint as faPrinter,
    faShare as faShareAlt,
    faCog as faGear,
    faUser as faPerson,
    faUsers as faPeople,
    faBuilding as faOffice,
    faMapMarkerAlt as faLocation,
    faCalendar as faCalendarAlt,
    faClock as faTime,
    faLock as faLocked,
    faUnlock as faUnlocked,
    faKey as faKeys,
    faBell as faNotification,
    faHeart as faLike,
    faStar as faFavorite,
    faFlag as faBookmark,
    faExclamationTriangle as faWarning,
    faInfoCircle as faInfo,
    faQuestionCircle as faHelp,
    faCheckCircle as faSuccess,
    faTimesCircle as faError,
    faExclamationCircle as faAlert,
    faMinus as faSubtract,
    faPlusCircle as faAddCircle,
    faMinusCircle as faRemoveCircle,
    faArrowUp as faChevronUp,
    faArrowDown as faChevronDown,
    faSort as faSortAlt,
    faSortUp as faSortAsc,
    faSortDown as faSortDesc,
    faExpand as faMaximize,
    faCompress as faMinimize,
    faExternalLinkAlt as faExternalLink,
    faLink as faChain,
    faUnlink as faUnchain
} from '@fortawesome/free-solid-svg-icons';

// Common button configurations
export const COMMON_BUTTONS = {
    ADD: {
        type: 'add',
        icon: faPlus,
        title: 'common.add',
        showWhen: 'always'
    },
    EDIT: {
        type: 'edit',
        icon: faEdit,
        title: 'common.edit',
        showWhen: 'whenSelected'
    },
    DELETE: {
        type: 'delete',
        icon: faTrash,
        title: 'common.remove',
        showWhen: 'whenSelected'
    },
    TRANSLATE: {
        type: 'translate',
        icon: faLanguage,
        title: 'common.translations',
        showWhen: 'whenSelected'
    },
    MOVE: {
        type: 'move',
        icon: faArrowsAlt,
        title: 'common.move',
        showWhen: 'whenSelected'
    },
    VIEW: {
        type: 'view',
        icon: faEye,
        title: 'common.view',
        showWhen: 'whenSelected'
    },
    VIEW_PDF: {
        type: 'viewPDF',
        icon: faFilePdf,
        title: 'common.viewPDF',
        showWhen: 'always'
    },
    DOWNLOAD_PDF: {
        type: 'downloadPDF',
        icon: faFilePdf,
        title: 'common.downloadPDF',
        showWhen: 'whenSelected'
    },
    EXCEL: {
        type: 'excel',
        icon: faFileExcel,
        title: 'common.downloadExcel',
        showWhen: 'always'
    },
    RIGHTS: {
        type: 'rights',
        icon: faGear,
        title: 'common.rights',
        showWhen: 'whenSelected'
    },
    DOWNLOAD: {
        type: 'download',
        icon: faDownload,
        title: 'common.download',
        showWhen: 'whenSelected'
    },
    UPLOAD: {
        type: 'upload',
        icon: faUpload,
        title: 'common.upload',
        showWhen: 'always'
    },
    COPY: {
        type: 'copy',
        icon: faCopy,
        title: 'common.copy',
        showWhen: 'whenSelected'
    },
    SAVE: {
        type: 'save',
        icon: faSave,
        title: 'common.save',
        showWhen: 'always'
    },
    CANCEL: {
        type: 'cancel',
        icon: faTimes,
        title: 'common.cancel',
        showWhen: 'always'
    },
    CONFIRM: {
        type: 'confirm',
        icon: faCheck,
        title: 'common.confirm',
        showWhen: 'always'
    },
    SEARCH: {
        type: 'search',
        icon: faSearch,
        title: 'common.search',
        showWhen: 'always'
    },
    FILTER: {
        type: 'filter',
        icon: faFilter,
        title: 'common.filter',
        showWhen: 'always'
    },
    REFRESH: {
        type: 'refresh',
        icon: faRefresh,
        title: 'common.refresh',
        showWhen: 'always'
    },
    BACK: {
        type: 'back',
        icon: faArrowLeft,
        title: 'common.back',
        showWhen: 'always'
    },
    NEXT: {
        type: 'next',
        icon: faArrowRight,
        title: 'common.next',
        showWhen: 'always'
    },
    PRINT: {
        type: 'print',
        icon: faPrint,
        title: 'common.print',
        showWhen: 'whenSelected'
    },
    SHARE: {
        type: 'share',
        icon: faShare,
        title: 'common.share',
        showWhen: 'whenSelected'
    },
    SETTINGS: {
        type: 'settings',
        icon: faCog,
        title: 'common.settings',
        showWhen: 'always'
    },
    USER: {
        type: 'user',
        icon: faUser,
        title: 'common.user',
        showWhen: 'always'
    },
    USERS: {
        type: 'users',
        icon: faUsers,
        title: 'common.users',
        showWhen: 'always'
    },
    BUILDING: {
        type: 'building',
        icon: faBuilding,
        title: 'common.building',
        showWhen: 'always'
    },
    LOCATION: {
        type: 'location',
        icon: faMapMarkerAlt,
        title: 'common.location',
        showWhen: 'always'
    },
    CALENDAR: {
        type: 'calendar',
        icon: faCalendar,
        title: 'common.calendar',
        showWhen: 'always'
    },
    TIME: {
        type: 'time',
        icon: faClock,
        title: 'common.time',
        showWhen: 'always'
    },
    LOCK: {
        type: 'lock',
        icon: faLock,
        title: 'common.lock',
        showWhen: 'whenSelected'
    },
    UNLOCK: {
        type: 'unlock',
        icon: faUnlock,
        title: 'common.unlock',
        showWhen: 'whenSelected'
    },
    KEY: {
        type: 'key',
        icon: faKey,
        title: 'common.key',
        showWhen: 'always'
    },
    NOTIFICATION: {
        type: 'notification',
        icon: faBell,
        title: 'common.notification',
        showWhen: 'always'
    },
    LIKE: {
        type: 'like',
        icon: faHeart,
        title: 'common.like',
        showWhen: 'whenSelected'
    },
    FAVORITE: {
        type: 'favorite',
        icon: faStar,
        title: 'common.favorite',
        showWhen: 'whenSelected'
    },
    BOOKMARK: {
        type: 'bookmark',
        icon: faFlag,
        title: 'common.bookmark',
        showWhen: 'whenSelected'
    },
    WARNING: {
        type: 'warning',
        icon: faExclamationTriangle,
        title: 'common.warning',
        showWhen: 'always'
    },
    INFO: {
        type: 'info',
        icon: faInfoCircle,
        title: 'common.info',
        showWhen: 'always'
    },
    HELP: {
        type: 'help',
        icon: faQuestionCircle,
        title: 'common.help',
        showWhen: 'always'
    },
    SUCCESS: {
        type: 'success',
        icon: faCheckCircle,
        title: 'common.success',
        showWhen: 'always'
    },
    ERROR: {
        type: 'error',
        icon: faTimesCircle,
        title: 'common.error',
        showWhen: 'always'
    },
    ALERT: {
        type: 'alert',
        icon: faExclamationCircle,
        title: 'common.alert',
        showWhen: 'always'
    },
    SUBTRACT: {
        type: 'subtract',
        icon: faMinus,
        title: 'common.subtract',
        showWhen: 'whenSelected'
    },
    ADD_CIRCLE: {
        type: 'addCircle',
        icon: faPlusCircle,
        title: 'common.addCircle',
        showWhen: 'always'
    },
    REMOVE_CIRCLE: {
        type: 'removeCircle',
        icon: faMinusCircle,
        title: 'common.removeCircle',
        showWhen: 'whenSelected'
    },
    CHEVRON_UP: {
        type: 'chevronUp',
        icon: faArrowUp,
        title: 'common.up',
        showWhen: 'always'
    },
    CHEVRON_DOWN: {
        type: 'chevronDown',
        icon: faArrowDown,
        title: 'common.down',
        showWhen: 'always'
    },
    SORT: {
        type: 'sort',
        icon: faSort,
        title: 'common.sort',
        showWhen: 'always'
    },
    SORT_UP: {
        type: 'sortUp',
        icon: faSortUp,
        title: 'common.sortUp',
        showWhen: 'always'
    },
    SORT_DOWN: {
        type: 'sortDown',
        icon: faSortDown,
        title: 'common.sortDown',
        showWhen: 'always'
    },
    EXPAND: {
        type: 'expand',
        icon: faExpand,
        title: 'common.expand',
        showWhen: 'always'
    },
    COMPRESS: {
        type: 'compress',
        icon: faCompress,
        title: 'common.compress',
        showWhen: 'always'
    },
    EXTERNAL_LINK: {
        type: 'externalLink',
        icon: faExternalLinkAlt,
        title: 'common.externalLink',
        showWhen: 'whenSelected'
    },
    LINK: {
        type: 'link',
        icon: faLink,
        title: 'common.link',
        showWhen: 'whenSelected'
    },
    UNLINK: {
        type: 'unlink',
        icon: faUnlink,
        title: 'common.unlink',
        showWhen: 'whenSelected'
    },
    COST_CENTERS: {
        type: 'costCenters',
        icon: faBuildingColumns,
        title: 'common.costCenters',
        showWhen: 'whenSelected'
    }
};

// Predefined button sets for common use cases
export const BUTTON_SETS = {
    CRUD: [COMMON_BUTTONS.ADD, COMMON_BUTTONS.EDIT, COMMON_BUTTONS.DELETE],
    CRUD_WITH_TRANSLATE: [COMMON_BUTTONS.ADD, COMMON_BUTTONS.EDIT, COMMON_BUTTONS.DELETE, COMMON_BUTTONS.TRANSLATE],
    VIEW_ACTIONS: [COMMON_BUTTONS.VIEW, COMMON_BUTTONS.PDF, COMMON_BUTTONS.EXCEL],
    FORM_ACTIONS: [COMMON_BUTTONS.SAVE, COMMON_BUTTONS.CANCEL],
    NAVIGATION: [COMMON_BUTTONS.BACK, COMMON_BUTTONS.NEXT],
    SEARCH_FILTERS: [COMMON_BUTTONS.SEARCH, COMMON_BUTTONS.FILTER, COMMON_BUTTONS.REFRESH],
    FILE_ACTIONS: [COMMON_BUTTONS.UPLOAD, COMMON_BUTTONS.DOWNLOAD, COMMON_BUTTONS.PDF, COMMON_BUTTONS.EXCEL],
    UTILITY: [COMMON_BUTTONS.SETTINGS, COMMON_BUTTONS.HELP, COMMON_BUTTONS.REFRESH]
};

// Helper function to create custom button configurations
export const createButton = (config) => ({
    ...config,
    showWhen: config.showWhen || 'always'
});

// Helper function to create button with custom onClick
export const createButtonWithHandler = (buttonType, onClick, customConfig = {}) => ({
    ...COMMON_BUTTONS[buttonType],
    onClick,
    ...customConfig
});

// Helper function to create multiple buttons with handlers
export const createButtonsWithHandlers = (buttonConfigs) => {
    return buttonConfigs.map(config => {
        if (typeof config === 'string') {
            return COMMON_BUTTONS[config];
        }
        return createButtonWithHandler(config.type, config.onClick, config);
    });
};
